// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JpP2","col":"styles_col__3EiRc"};